<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-12 col-md-8">
          <h5>Class Setup Details</h5>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <class-setup :rolesetting="pagepermission" @created="handleCreated"/>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ClassSetup from '@/components/classsetup/Forms/Setup/index'

export default {
  components: {
    ClassSetup,
  },
  beforeMount: function() {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('class-setup', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  // watch: {
  //   pageSize(val) {
  //     console.log('pageSize', val)
  //   },
  //   current(val) {
  //     console.log('current', val)
  //   },
  // },
  methods: {
    handleCreated: function() {
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
    },
    onChange(current) {
      this.current = current
    },
  },
}
</script>
